export default "__VITE_ASSET__CHatuSsj__"